import { l as x } from "./lodash-5ofSKtz3.mjs";
import { j as l } from "./jsx-runtime-3tyXYecC.mjs";
import { useRef as X, useMemo as j, useEffect as D, useContext as O, useState as P, isValidElement as I, createElement as H, createContext as Y } from "react";
import { Controller as Q, useForm as Z, useFormContext as tt, FormProvider as et } from "react-hook-form";
import { C as rt } from "./checkbox-DiWnVoeQ.mjs";
import { C as nt } from "./checkbox-group-jz_F7j5y.mjs";
import { C as ot } from "./currency-picker-field-T3oPjf4m.mjs";
import { C as st } from "./currency-picker-provider-CTRNrW3S.mjs";
import { m as V } from "./mui-DV6TgX2g.mjs";
import { c as it } from "./index-DkZ16bcJ.mjs";
import { B as F } from "./Box-B5hjovXR.mjs";
import { T as R } from "./text-field-ZOMRKQAY.mjs";
import { S as ct } from "./section-header-Bma-sii2.mjs";
import { S as ut } from "./select-field-BuE_t-Fz.mjs";
import { T as dt } from "./text-area-CajlHzg4.mjs";
import { T as L } from "./Typography-DfkimCSn.mjs";
import { S as at } from "./sensitive-text-field-CgY8Ts9P.mjs";
import { D as lt } from "./date-picker-FVIC1w4I.mjs";
import { T as ft } from "./typography-Bj_iezxf.mjs";
import { i as pt } from "./transformSpacingProps-m0OnDuSS.mjs";
function q(t, e) {
  return Array.isArray(t) ? t.includes(e) : typeof t == "object" ? e in t : !1;
}
const be = 1.25, ke = {
  // Pixel heights
  teenie: 28,
  small: 32,
  medium: 34,
  large: 36,
  biggie: 42
}, me = {
  // used with theme spacing
  teenie: 0.875,
  small: 0.9375,
  medium: 0.625,
  large: 0.625,
  biggie: 1.315
}, Se = {
  SSN: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
}, yt = (t) => typeof t == "boolean" ? {
  checked: t
} : typeof t == "object" ? t : { value: t }, ht = (t, e, n) => (r, ...o) => {
  var c, i;
  if (n) {
    const a = [...o, e];
    return t(n(r, ...a));
  }
  if (!r) return t(r);
  if (r.hasOwnProperty("target"))
    return (c = r.target) != null && c.hasOwnProperty("checked") ? t(r.target.checked) : t((i = r.target) == null ? void 0 : i.value);
  if (r.hasOwnProperty("checked"))
    return t(r.checked);
  if (r.hasOwnProperty("value"))
    return t(r.value);
  t(r);
}, xt = (t) => (e, { isControlled: n, rules: r = {}, defaultValue: o = "", name: c, ...i }) => {
  if (!n)
    return /* @__PURE__ */ l.jsxs(L, { color: "error", variant: "caption", children: [
      c,
      " was not registered as a controlledField"
    ] });
  const { setValueAs: a, ...f } = r;
  return /* @__PURE__ */ l.jsx(
    Q,
    {
      control: t,
      defaultValue: o,
      name: c,
      render: ({ field: u }) => {
        const d = yt(u.value), s = ht(u.onChange, u.value, a), y = () => u.onBlur();
        y.__fabricInternalOnlySupressBlur = !0;
        const h = { ...i, ...u, ...d, name: c, onBlur: y, onChange: s };
        return e(h);
      },
      rules: f
    },
    c
  );
}, gt = (t) => {
  if (t !== !1)
    return t === !0 ? "Required" : t;
}, M = (t, e, n) => {
  const [r, ...o] = e;
  return o.length === 0 ? t[r] = n : (t[r] || (t[r] = isNaN(o[0]) ? {} : []), t[r] = M(t[r], o, n)), t;
}, T = (t, e, n = {}) => t.reduce((r, { name: o, autoRegister: c, required: i, maxLength: a, validate: f, setValueAs: u, ...d }) => {
  const s = { maxLength: a, validate: f, setValueAs: u }, y = {};
  i && (s.required = gt(i), y.required = !0);
  const h = c ? e(o, s) : { isControlled: !0, rules: s };
  return M(r, o.split("."), {
    ...d,
    ...h,
    ...y,
    name: o
  });
}, n), bt = (t, e) => {
  const n = T([t], e);
  return x.get(n, t.name);
}, kt = (t, e) => {
  const n = Z(e), { register: r, control: o } = n, c = X([]);
  x.isEqual(c.current, t) || (c.current = t);
  const i = j(() => !t || t.length === 0 ? {} : T(t, r), [c.current, r]), a = xt(o), f = (u) => bt(u, r);
  return D(() => {
    Object.entries(i).forEach(([u, d]) => {
      pt(d) && "value" in d && n.setValue(u, d.value);
    });
  }, [n, i]), {
    fields: i,
    controlled: a,
    registerControlled: f,
    ...n
  };
}, mt = (t) => {
  const e = tt(), { register: n, fields: r } = e, o = j(() => t ? T(t, n, r) : r, [JSON.stringify(t), JSON.stringify(r), n]);
  return {
    ...e,
    fields: o
  };
}, St = (t) => t === "Required" ? "" : t, Ft = (t) => ({
  note: t ? St(t.message) : "",
  status: t ? "error" : void 0
});
var p = /* @__PURE__ */ ((t) => (t.Checkbox = "Checkbox", t.CheckboxGroup = "CheckboxGroup", t.CurrencyPickerField = "CurrencyPickerField", t.DateField = "DateField", t.Group = "Group", t.HiddenInput = "HiddenInput", t.IntField = "IntField", t.PercentageField = "PercentageField", t.Section = "Section", t.SensitiveTextField = "SensitiveTextField", t.Select = "Select", t.SelectField = "SelectField", t.TextArea = "Textarea", t.TextField = "TextField", t.Text = "Text", t))(p || {});
function Ct({ element: t }) {
  var s;
  const e = typeof t.name == "string" ? t.name : "", n = O(st), r = Array.isArray(t.value) && typeof t.value[0] == "string" ? t.value[0] : "", o = Array.isArray(t.value) && typeof t.value[1] == "string" ? t.value[1] : "", c = (s = t.currency) == null ? void 0 : s.symbol, i = o && c ? {
    ...t.currency,
    name: c,
    code: o
  } : void 0, [a, f] = P(r), [u, d] = P(i);
  return /* @__PURE__ */ l.jsx(
    ot,
    {
      ...t,
      inputNames: { amount: `${e}[0]`, currency: `${e}[1]` },
      onChange: (y) => {
        if (f(y), typeof t.onChange == "function") {
          const h = x.isEmpty(y), g = x.isEmpty(u == null ? void 0 : u.code) && x.isEmpty(n.defaultCurrency), k = h || g ? null : [y, (u == null ? void 0 : u.code) || n.defaultCurrency];
          t.onChange(k);
        }
      },
      onSelectCurrency: (y) => {
        if (d(y), typeof t.onChange == "function") {
          const h = x.isEmpty(a) || x.isEmpty(y.code) ? null : [a, y.code];
          t.onChange(h);
        }
      },
      selectedCurrency: u,
      submitUnmaskedValue: !0,
      useUnmaskedValue: !0,
      value: a
    }
  );
}
function jt({ element: t }) {
  return /* @__PURE__ */ l.jsx(ft, { children: t.type });
}
const Rt = V(({ palette: t, spacing: e, typography: n }) => {
  var r;
  return {
    root: {
      display: "block",
      color: t.text.secondary,
      fontSize: (r = n.small) == null ? void 0 : r.fontSize,
      marginBottom: e(0.5)
    }
  };
}), Tt = ({ children: t, className: e = "" }) => {
  const n = Rt();
  return /* @__PURE__ */ l.jsx("span", { className: it(n.root, e), children: t });
};
function J(t, { formElements: e, layout: n }) {
  const r = e[t], o = n[t], c = [p.Group, p.Section], i = Array.isArray(o == null ? void 0 : o.childIds) && (o == null ? void 0 : o.childIds.length);
  return !!(c.includes(r == null ? void 0 : r.type) || i || r != null && r.groupable);
}
function wt(t, { formElements: e }) {
  const { hidden: n, type: r } = e[t];
  return [p.HiddenInput].includes(r) || !!n;
}
function Et(t, e) {
  const { layout: n } = e, { childIds: r } = n[t];
  return (r == null ? void 0 : r.every((o) => wt(o, e) || J(o, e))) || !1;
}
function vt(t, e) {
  const { layout: n } = e, { childIds: r } = n[t];
  return (r == null ? void 0 : r.some((o) => J(o, e))) || !1;
}
function At({ children: t, element: e, formConfig: n }) {
  var d;
  const { layout: r } = n, { id: o } = e, c = ((d = r[o]) == null ? void 0 : d.childIds) || [], i = typeof e.label == "string" ? e.label : "", a = Et(o, n), f = a || vt(o, n), u = /* @__PURE__ */ l.jsx(F, { columnGap: f ? 1.25 : 1, display: "flex", flexDirection: a ? "column" : "row", rowGap: 1, children: t });
  return (!c || c.length < 1) && console.error(`An empty group with the id: "${o}" was found in your form layout.`), i ? /* @__PURE__ */ l.jsxs("label", { children: [
    /* @__PURE__ */ l.jsx(Tt, { children: i }),
    u
  ] }) : u;
}
function Bt({ element: t }) {
  const { type: e, ...n } = t;
  return /* @__PURE__ */ l.jsx("input", { type: "hidden", ...n });
}
function Nt({ element: t }) {
  return /* @__PURE__ */ l.jsx(R, { ...t, width: 2 });
}
function Gt({ element: t }) {
  const { note: e } = t;
  return /* @__PURE__ */ l.jsx(
    R,
    {
      ...t,
      note: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        /* @__PURE__ */ l.jsx(
          F,
          {
            sx: {
              color: "gray.700",
              display: "inline-block",
              fontWeight: "fontWeightRegular",
              marginLeft: 0.5,
              marginRight: 1.5,
              verticalAlign: "baseline"
            },
            children: "%"
          }
        ),
        e
      ] }),
      width: 2
    }
  );
}
const Pt = V(({ palette: t, spacing: e }) => ({
  root: {
    borderBottom: `1px solid ${t.gray[300]}`,
    marginBottom: e(2),
    width: "100%",
    "&:last-child": {
      borderBottom: "none",
      marginBottom: 0,
      "& $children": {
        paddingBottom: 0
      }
    }
  },
  children: {
    paddingBottom: e(2.5)
  }
})), Wt = (t) => {
  const { children: e, icon: n, label: r, subLabel: o, ...c } = t, i = Pt();
  return /* @__PURE__ */ l.jsxs(F, { ...c, className: i.root, children: [
    r && /* @__PURE__ */ l.jsx(ct, { icon: n, label: r, subtitle: o }),
    e ? /* @__PURE__ */ l.jsx("div", { className: i.children, children: e }) : null
  ] });
};
function $t({ children: t, element: e, formConfig: n }) {
  var u;
  const { id: r } = e, { layout: o } = n, c = ((u = o[r]) == null ? void 0 : u.childIds) || [], i = typeof e.icon == "object" && I(e.icon) ? e.icon : void 0, a = typeof e.label == "string" ? e.label : void 0, f = typeof e.subLabel == "string" ? e.subLabel : void 0;
  return /* @__PURE__ */ l.jsx(Wt, { icon: i, label: a, subLabel: f, children: c.length ? /* @__PURE__ */ l.jsx(F, { display: "flex", flexDirection: "column", rowGap: 2, children: t }) : null });
}
function w(t) {
  return ((r) => typeof r == "number" || typeof r == "string" && typeof JSON.parse(r) == "number")(t) ? {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    100: 100
  }[t] : void 0;
}
function W({ element: t }) {
  const { onChange: e, type: n, width: r, ...o } = t, c = w(r), a = c || 5;
  return /* @__PURE__ */ l.jsx(
    ut,
    {
      onChange: (f) => {
        var u;
        typeof e == "function" && e(typeof ((u = f.target) == null ? void 0 : u.value) > "u" ? null : f.target.value);
      },
      width: a,
      ...o
    }
  );
}
function Dt({ element: t }) {
  var o;
  const e = (o = t.sensitive) == null ? void 0 : o.value, n = t["data-secure-field-type"], r = x.omit(t, ["className", "sensitive", "token", "type", "validation"]);
  return /* @__PURE__ */ l.jsx(at, { fieldType: n, sensitiveValue: e, width: 4, ...r });
}
function Ot({ element: t }) {
  const { id: e, type: n, width: r, ...o } = t, c = w(r);
  return /* @__PURE__ */ H(dt, { ...o, key: e, minRows: 3, width: c || 10 });
}
function It({ element: t }) {
  const { id: e, type: n, width: r, ...o } = t, c = w(r);
  return /* @__PURE__ */ l.jsx(R, { ...o, width: c || 4 });
}
function Ht({ element: t }) {
  const { value: e } = t;
  if (!(typeof e == "string" || typeof e == "object" && I(e)))
    throw new Error("Text renderer received a bad setting for `value`.");
  return /* @__PURE__ */ l.jsx(L, { children: e });
}
function C(t) {
  return ({ element: e }) => /* @__PURE__ */ H(t, { ...e, key: e.id });
}
const Vt = {
  [p.Checkbox]: C(rt),
  [p.CheckboxGroup]: C(nt),
  [p.CurrencyPickerField]: Ct,
  [p.DateField]: C(lt),
  [p.Group]: At,
  [p.HiddenInput]: Bt,
  [p.IntField]: Nt,
  [p.PercentageField]: Gt,
  [p.Section]: $t,
  [p.Select]: W,
  [p.SelectField]: W,
  [p.TextArea]: Ot,
  [p.TextField]: It,
  [p.Text]: Ht,
  [p.SensitiveTextField]: Dt
};
function Lt(t) {
  return Vt[t];
}
function qt(t, e, n) {
  let r = n;
  if (typeof e.getRenderer == "function") {
    const o = e.getRenderer(t);
    typeof o == "function" && (r = o);
  }
  return r;
}
function Mt(t) {
  return Object.values(p).includes(t);
}
function E(t, e) {
  let n = Mt(t.type) ? Lt(t.type) : void 0;
  n || (n = jt);
  const r = e ? qt(t, e, n) : n;
  if (!r)
    throw new Error(`Could not find renderer for type: "${t.type}".`);
  return r;
}
function Jt(t, e, n) {
  const { layout: r } = e;
  return t.map((o) => r[o] ? _(o, e, n) : (console.error(`Could not find a item on the layout with the "id" of "${o}".`), null)) || [];
}
function _(t, e, n) {
  var f;
  const { formElements: r, layout: o } = e, c = r[t];
  let i = (f = o[t]) == null ? void 0 : f.childIds;
  i != null && i.includes(t) && (i = i.filter((u) => u !== t), console.error(`A parent layout item cannot reference itself as a child. Looking at you "${t}" 👀.`));
  const a = E(c, n);
  return /* @__PURE__ */ l.jsx(a, { "data-layout-id": t, element: c, formConfig: e, renderOptions: n, children: Array.isArray(i) && i.length > 0 ? Jt(i, e, n) : null }, t);
}
function _t(t, e) {
  return _("root", t, e);
}
function Fe(t, e) {
  return Array.isArray(t) ? t.includes(e) : typeof t == "object" ? e in t : !1;
}
const $ = {
  xxxshort: 1,
  xxshort: 2,
  xshort: 3,
  short: 4,
  long: 5,
  xlong: 6,
  xxlong: 8,
  xxxlong: 9,
  xxxxlong: 10,
  fullWidth: 100,
  autoWidth: 100
};
function Ce(t) {
  var a, f;
  const e = x.cloneDeep(t), n = {}, r = !e.idsByToken, o = !e.idsByName;
  n.idsByToken = r ? {} : { ...e.idsByToken }, n.idsByName = o ? {} : { ...e.idsByName }, n.formElements = (a = e.formElements) == null ? void 0 : a.reduce((u, { value: d, ...s }) => {
    var y, h, g, k, S, v, A, B, N, G;
    if (Array.isArray(d) && d.length === 1 && (d = d[0]), (y = s == null ? void 0 : s.className) != null && y.includes("Width") || (h = s == null ? void 0 : s.className) != null && h.includes("long") || (g = s == null ? void 0 : s.className) != null && g.includes("short")) {
      const m = s.className.split(" ");
      let b = 0;
      for (; b < m.length; ) {
        if ($[m[b]]) {
          s.width = $[m[b]];
          break;
        }
        b += 1;
      }
    }
    return ((k = e.layout[s.id]) == null ? void 0 : k.type) === "CheckboxGroup" && (d = (S = s.items) == null ? void 0 : S.reduce((m, b) => (b.checked === !0 && (m.push(b.value), delete b.checked), m), [])), ((v = e.layout[s.name]) == null ? void 0 : v.type) === "Checkbox" && (d = !!(s != null && s.checked), delete s.checked), ((A = e.layout[s.name]) == null ? void 0 : A.type) === "SensitiveTextField" && (d = void 0), ((B = e.layout[s.name]) == null ? void 0 : B.type) === "CurrencyPickerField" && (d = x.isEmpty(s.amount) || x.isEmpty(s.currency) ? void 0 : [s.amount, s.currency.code]), ((N = e.layout[s.name]) == null ? void 0 : N.type) === "PercentageField" && s.note === "%" && delete s.note, ["SelectField", "Select"].includes((G = e.layout[s.name]) == null ? void 0 : G.type) && Array.isArray(d) && !s.canSelectMultiple && (d = d[0]), s.name && (s = { ...s, name: s.name.replace(/\[\d*\]/, "") }, o && (n.idsByName[s.name] = s.id)), u[s.id] = { ...s, defaultValue: d }, r && s.token && (n.idsByToken[s.token] = s.id), u;
  }, {});
  const c = (f = e.formElements) == null ? void 0 : f.reduce((u, d) => (u[d.name] && console.log(`collision for ${d.name}, id: ${d.id}`), u[d.name] = { ...d }, u), {}), i = Object.values(e.layout);
  return n.layout = i == null ? void 0 : i.reduce((u, d) => {
    var y;
    let s = d.key === "root" ? "root" : (y = c[d.key]) == null ? void 0 : y.id;
    return (!s || s === "root") && (s = d.key, n.formElements[s] || (n.formElements[s] = d.settings), r && d.settings.token && (n.idsByToken[d.settings.token] = s), s === "root" && (n.formElements[s].id = "root")), u[s] = { id: s, childIds: [] }, d.childKeys.length > 0 && (u[s].childIds = d.childKeys.reduce((h, g) => {
      var k, S;
      return ((k = c[g]) == null ? void 0 : k.id) === s || g === s || h.push(((S = c[g]) == null ? void 0 : S.id) || g), h;
    }, []), u[s].childIds.forEach((h) => {
      u[h] && (u[h].parentId = s);
    })), d.type && (n.formElements[s].type = d.type), u;
  }, {}), n;
}
const z = Y({});
function zt(t, e, n) {
  const { formState: r, fields: o } = t, { errors: c } = r;
  let i = o[n], a = q(c, n) ? c[n] : void 0;
  return typeof e == "function" && (a = e(n, r)), a && (i = { ...i, ...Ft(a || c[n]) }), i.isControlled || (i = { ...i, ...t.register(n, i.rules) }), i;
}
function Kt({ children: t, element: e, formConfig: n }) {
  const r = mt(), { getErrorState: o, getRenderer: c } = O(z) || {}, { name: i } = e;
  if (typeof i != "string" || !q(r.fields, i))
    throw new Error(
      `There is a problem with your configuration. An item with the name of "${i}" has not been registered with the provided form controller.`
    );
  const a = zt(r, o, i);
  return r.controlled((f) => {
    const u = E(e, { getRenderer: c });
    if (typeof u != "function")
      throw new Error(`Could not find a renderer for your form element with the name ${i} and type ${e.type}`);
    return /* @__PURE__ */ l.jsx(u, { element: { ...f, ...e }, formConfig: n, children: t });
  }, a);
}
const Ut = (t) => typeof t.name == "string";
function je(t, e, n = {}) {
  return /* @__PURE__ */ l.jsx(et, { ...e, children: /* @__PURE__ */ l.jsx(z.Provider, { value: n, children: _t(t, {
    getRenderer: (r) => Ut(r) ? Kt : E(r, n)
  }) }) });
}
function Xt(t) {
  return typeof t.name == "string";
}
function Yt(t) {
  return Object.values(t).filter(Xt);
}
function Re(t = {}) {
  const e = j(() => Yt(t) || [], [t]);
  return kt(e);
}
function K(t, e) {
  const { watch: n } = t;
  D(() => {
    const r = n((o, { name: c, type: i }) => {
      c && !Array.isArray(c) && i === "change" && setTimeout(() => {
        const a = o;
        e(c, a[c], a);
      });
    });
    return () => r.unsubscribe();
  }, [e, n]);
}
function U(t, e) {
  const n = Object.entries(t.idsByToken).reduce((r, [o, c]) => (r[c] = o, r), {});
  return Object.entries(e).reduce((r, [o, c]) => {
    const i = n[o];
    return i && (r[i] = c), r;
  }, {});
}
function Te(t, e, n) {
  K(e, (r, o, c) => {
    if (!n)
      return;
    const { formElements: i = {} } = n, { token: a } = i[r] || {};
    a && t(a, o, U(n, c));
  });
}
function we(t, e, n) {
  K(e, (r, o, c) => {
    if (!n)
      return;
    const { formElements: i = {} } = n, a = Object.values(i).find((f) => f.name === r);
    a && t(a, o, U(n, c));
  });
}
const Ee = {
  layout: {
    root: { id: "root" }
  },
  formElements: {
    root: { id: "root", type: "group" }
  },
  idsByName: {},
  idsByToken: {}
};
export {
  Ct as C,
  jt as D,
  p as F,
  At as G,
  ke as H,
  Nt as I,
  Gt as P,
  $t as S,
  Ot as T,
  be as X,
  me as Y,
  mt as a,
  Re as b,
  K as c,
  Te as d,
  Ft as e,
  we as f,
  yt as g,
  ht as h,
  Ee as i,
  _t as j,
  E as k,
  Fe as l,
  Se as m,
  w as n,
  Bt as o,
  W as p,
  Ce as q,
  je as r,
  Dt as s,
  It as t,
  kt as u,
  Ht as v
};
//# sourceMappingURL=constants-BCcq0vBK.mjs.map
